<mat-card class="__pop z-manual-elevation c-soft-elevation has-no-padding">
  <div class="__search">
    <zui-local-search-field
      placeholder="Search projects..."
      [maxWidth]="460"
      [autofocus]="true"
      (valueChange)="onSearchChange($event)">
    </zui-local-search-field>
  </div>

  <div class="__list">
    @if (filteredProjects().length === 0) {
      <div class="__empty">
        @if (searchQuery()) {
          <span>No projects found matching "{{ searchQuery() }}"</span>
        } @else {
          <span>No projects available to add</span>
        }
      </div>
    } @else {
      @for (result of filteredProjects(); track result.item.projectId) {
        <div
          class="__project"
          matTooltipClass="c-zerops-tooltip"
          matTooltipPosition="above"
          [matTooltip]="editingUserRole() === clientUserRole.Admin || editingUserRole() === clientUserRole.Owner
            ? 'User\'s default team member role includes Full access. Setting it explicitly you override it.'
            : ''"
          [class.__project--selected]="result.item.selectedRole !== 'NONE'">

          <div class="__project-info">
            <div class="__project-name">
              <zef-fuse-highlight
                [data]="result.item"
                [key]="'displayName'"
                [matches]="result.matches">
              </zef-fuse-highlight>
            </div>
            @if (result.item.tags.length > 0) {
              <div class="__project-tags">
                @for (tag of result.item.tags; track tag) {
                  <zui-tag class="__tag">{{ tag }}</zui-tag>
                }
              </div>
            }
          </div>

          <!--
          <div class="__project-controls">
            <mat-checkbox
              class="__checkbox"
              [checked]="result.item.selectedRole === 'READ_ONLY'"
              [disabled]="!result.item.canAssignReadOnly"
              (change)="onRoleToggle(result.item.projectId, 'READ_ONLY')">
              Read
            </mat-checkbox>

            <mat-checkbox
              class="__checkbox"
              [checked]="result.item.selectedRole === 'ADMIN'"
              [disabled]="!result.item.canAssignAdmin"
              (change)="onRoleToggle(result.item.projectId, 'ADMIN')">
              Full
            </mat-checkbox>
          </div>
          -->

          <div>
            <mat-radio-group
              class="__project-controls"
              [value]="result.item.selectedRole === 'NONE' ? 'UNSET' : result.item.selectedRole"
              (change)="onRoleToggle(result.item.projectId, $event.value)">

              <mat-radio-button
                class="__radibutton"
                value="READ_ONLY"
                [disabled]="!result.item.canAssignReadOnly">
                Read
              </mat-radio-button>

              <mat-radio-button
                class="__radibutton"
                value="ADMIN"
                [disabled]="!result.item.canAssignAdmin">
                Full
              </mat-radio-button>

              <mat-radio-button
                class="__radibutton"
                value="UNSET"
                [disabled]="result.item.selectedRole !== 'READ_ONLY' && result.item.selectedRole !== 'ADMIN'">
                Unset
              </mat-radio-button>

            </mat-radio-group>
          </div>

        </div>
      }
    }
  </div>

  <div class="__footer">
    <button
      type="button"
      mat-flat-button
      color="accent"
      class="__button __confirm"
      [disabled]="selectedCount() === 0"
      (click)="onConfirm()">
      Add {{ selectedCount() > 0 ? selectedCount() : '' }} {{ selectedCount() === 1 ? 'project' : 'projects' }}
    </button>
  </div>
</mat-card>
